import classNames from 'classnames'

type HeaderProps = {
  readonly title: string
  readonly description: string
  readonly className?: string
}

export function AlarmMomentsHeader({
  title,
  description,
  className
}: HeaderProps) {
  const titleParts = title.split(/(®)/)

  return (
    <div className="mb-2 px-3 md:px-0" data-component="AlarmMomentsHeader">
      <h2
        className={classNames(
          'text-heading-3-size leading-h3-height my-2.5 text-center md:my-4',
          className
        )}
      >
        {titleParts.map((part, index) =>
          part === '®' ? (
            <sup className="text-xl" key={index}>
              ®
            </sup>
          ) : (
            part
          )
        )}
      </h2>
      <p className="m-0 text-center">{description}</p>
    </div>
  )
}
